import React from 'react';
import ImgServicePriceCalculator from '../../components/sections/img-service-price-calculator/img-service-price-calculator';
import './img-service-price-calculator-view.scss';
import ServiceHandler from '../../services/service-handler';
import useGraphqlPersistQueryContent from '../../hooks/use-graphql-persist-query-content';
import { ImgSpcPageData } from '../../models/img-service-price-calculator/img-service-price-calculator';
import { ActivityIndicator } from '../../components/common/activity-indicator/activity-indicator';

export function ImgServicePriceCalculatorView() {
    const {
        currentCountryCode,
        currentLanguageRegionCode,
    } = ServiceHandler.AppConfigurationService;

    const { data, loading, error } = useGraphqlPersistQueryContent<
        ImgSpcPageData
    >('img-spc-page', {
        mainPath: `/content/dam/global-owner/ford/${currentCountryCode}/${currentLanguageRegionCode}/content-fragments/img-spc/img-spc-main`,
    });

    console.log({
        data,
        loading,
        error,
    });

    if (loading || (error && !data)) {
        return <ActivityIndicator className="full-height" />;
    }

    return (
        <div className="img-service-price-calculator-view">
            <main className="img-service-price-calculator-main">
                <h1 className="img-spc-title">
                    {
                        data?.imgSpcMainByPath?.item
                            ?.pathToImgSpcHeadingContentFragment?.headerTitle
                    }
                </h1>
                <ImgServicePriceCalculator data={data} />
            </main>
        </div>
    );
}

export default ImgServicePriceCalculatorView;
